import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const fetchAllSecurityGroups = createAsyncThunk(
    'common/fetchSecurityGroups',
    async ()=> {
        const { axiosGet } = useCustomAxios();
        try {
            // const response = await axiosGet(`${API_ENDPOINTS.getSecurityGroup}`);
            const response = await axiosGet(`${API_ENDPOINTS.fetchAllSecurityGroups}`);
            return { data: response.data, status: response.status };
          } catch (error: any) {
            return {
              error: error.response.data.message,
              status: error.response.status,
            };
          }
    }
)

export const fetchPermissions = createAsyncThunk(
  'common/fetchPermissions',
  async ()=> {
      const { axiosGet } = useCustomAxios();
      try {
          const response = await axiosGet(`${API_ENDPOINTS.fetchPermissions}`);
          return { data: response.data, status: response.status };
        } catch (error: any) {
          return {
            error: error.response.data.message,
            status: error.response.status,
          };
        }
  }
)
export const getAllRelationshipTypesApi = createAsyncThunk(
  'common/getAllRelationshipTypes',
  async ()=> {
      const { axiosGet } = useCustomAxios();
      try {
          const response = await axiosGet(`${API_ENDPOINTS.getAllRelationshipTypes}`);
          return { data: response.data, status: response.status };
        } catch (error: any) {
          return {
            error: error.response.data.message,
            status: error.response.status,
          };
        }
  }
)

export const removeRelationshipTypesApi = createAsyncThunk(
  'common/removeRelationshipTypes',
  async (reqBody:any)=> {
      const { axiosPost } = useCustomAxios();
      try {
          const response = await axiosPost(`${API_ENDPOINTS.removeRelationshipTypes}`, reqBody);
          return { data: response.data, status: response.status };
        } catch (error: any) {
          return {
            error: error.response.data.message,
            status: error.response.status,
          };
        }
  }
)

export const getAllGeoLocations = createAsyncThunk(
  '/common/getAllGeoLocations',
  async () => {
    const { axiosGet } = useCustomAxios();
    try {
      const response = await axiosGet(`${API_ENDPOINTS.getAllGeoLocations}`);
      return { data: response.data, status: response.status };
    }
    catch(error: any) {
      return { error: error.response.data.message, status: error.response.status }
    }
  }
)

export const sendOtpAPI = createAsyncThunk(
  'common/sendOtp',
  async (reqBody:any)=> {
    const { axiosPost } = useCustomAxios();
      return axiosPost(`${API_ENDPOINTS.sendOtp}`, reqBody);
  }
)

export const verifyOtpAPI = createAsyncThunk(
  'common/verifyOtp',
  async (reqBody:any)=> {
    const { axiosPost } = useCustomAxios();
    return axiosPost(`${API_ENDPOINTS.verifyOtp}`, reqBody);
  }
)

export const getUOMByType = createAsyncThunk(
  'common/getUOMByType',
  async (type:any)=> {
    const { axiosGet } = useCustomAxios();
    try {
        const response = await axiosGet(`${API_ENDPOINTS.getUOMByType}${type}`);
        return { data: response.data, status: response.status };
      } catch (error: any) {
        return {
          error: error.response.data.message,
          status: error.response.status,
        };
      }
}
)


